export * from './ip-permitido-slice'